import React, { memo } from 'react';
import { Button } from '@components/Button';
import { StyledHeroText, TextPairingWrapper, StyledBox } from './FooterSection.styles';
import { useTranslation } from 'react-i18next';

export const FooterSectionContent = memo(({ mobile }: { mobile?: boolean }) => {
  const { t } = useTranslation('ourStory');
  const footerSection = t('footerSection');
  return (
    <TextPairingWrapper>
      <StyledHeroText variant="hed56" color="neutra6" tagName="h2">
        {footerSection.title}
      </StyledHeroText>
      <StyledBox marginTop={[6, 7]}>
        <Button id={`findPerfectRoleExploreCareers${mobile ? 'Mobile' : ''}`} variant="prime" forwardedAs="a" href={t('allPostionsCta')}>
          {footerSection.cta}
        </Button>
      </StyledBox>
    </TextPairingWrapper>
  );
});
